import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';

export const RadioButtonsGroup = props => {
    const { field, name, options } = props;

    return (
        <FormControl component="fieldset" error={props.error}>
            <FormLabel component="legend">{field}</FormLabel>
            <RadioGroup row={props.row} aria-label={name} name={name} value={props.value} onChange={props.onChange}>
                {options.map((op, key) => 
                    <FormControlLabel key={key} value={op.value} control={<Radio />} label={op.label} disabled={props.disabled} />
                )}
            </RadioGroup>
            {props.error && 
                <FormHelperText>{props.helperText}</FormHelperText>
            }
        </FormControl>
    );
}

export default RadioButtonsGroup;